import { render, staticRenderFns } from "./administration.vue?vue&type=template&id=6ca61a30&scoped=true&"
import script from "./administration.vue?vue&type=script&lang=js&"
export * from "./administration.vue?vue&type=script&lang=js&"
import style0 from "./administration.vue?vue&type=style&index=0&id=6ca61a30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca61a30",
  null
  
)

export default component.exports